import { usePartner } from 'components/app/routes/usePartner';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { PARTNERS } from 'config/app-config';

export const useIsEmailQuoteQualified = () => {
  const { releaseAbandonedCart } = useFlags();
  const { isDSJourney, activePartner } = usePartner();
  const isQuoteByEmailJourney = activePartner[PARTNERS.QUOTE_BY_EMAIL];
  const isAbandonCartJourney = activePartner[PARTNERS.ABANDONED_CART];

  // returning from email for abandon cart
  if (isAbandonCartJourney) return false;

  // returning from email for quote by email
  if (isQuoteByEmailJourney) return true;

  return isDSJourney && !releaseAbandonedCart;
};
